import React, { useEffect, useState } from "react";
import classNames from "classnames";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Typography,
  Button,
  Paper,
} from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from "assets/jss/material-kit-react/views/profilePage.js";
import { darkBlueColor, grayTextColor, yelloColor } from "../../Utils/index";
import AdmissionEnquiry from "views/Admission/AdmissionEnquiry";

const useStyles = makeStyles(styles);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: darkBlueColor,
    fontSize: 16,
    fontFamily: "Rubik, sans-serif",
    color: theme.palette.common.white,
    padding: "12px 16px",
  },
  body: {
    fontSize: 15,
    fontFamily: "Rubik, sans-serif",
    fontWeight: 500,
    color: darkBlueColor,
    padding: "10px 16px",
  },
}))(TableCell);

const StyledTableRow = withStyles(() => ({
  root: {
    "&:nth-of-type(even)": { backgroundColor: "#f8faff" },
  },
}))(TableRow);

const SectionCard = ({ title, children, noPadding }) => (
  <div style={{ marginTop: 28, borderRadius: 8, overflow: "hidden", border: "1px solid #e0e0e0" }}>
    <div style={{ backgroundColor: "#002347", padding: "14px 20px" }}>
      <h3 style={{ color: "#fdc632", fontFamily: "Rubik, sans-serif", fontWeight: "700", margin: 0, fontSize: 17 }}>
        {title}
      </h3>
    </div>
    <div style={noPadding ? {} : { padding: 20 }}>
      {children}
    </div>
  </div>
);

const infoRows = [
  ["Duration",            "3 Years"],
  ["Minimum Eligibility", "12th with 50% minimum aggregate (any stream)"],
  ["Scholarship",         "Available for reserved categories & economically weaker sections"],
  ["Career Options",      "Scientist, Scientific Assistant, Research Analyst, Teacher, Lecturer, Chemist, Researcher, Biostatistician, Technical Writer, Consultant & more"],
];

const bscPcmFees = [
  ["ACE Form Fees",  "100"],
  ["ACE Registration Fees",       "1,400"],
  ["Identity Card",               "100"],
  ["Library Fees",                "1,000"],
  ["Caution Fees (Refundable Security)",                "1,000"],
  ["University Fees (As Per Norms)",             "850"],
  ["Co-Curricular Activity Fees", "500"],
  ["Sports Fees",                 "350"],
  ["Tuition Fees",                "18,000"],
  ["Industrial Visit",            "300"],
  ["Laboratory Charges",          "2,400"],
];

const installments = [
  { month: "July",   amount: "6,000" },
  { month: "August", amount: "2,400" },
  { month: "Sep",    amount: "2,400" },
  { month: "Oct",    amount: "2,400" },
  { month: "Nov",    amount: "2,400" },
  { month: "Dec",    amount: "2,400" },
  { month: "Jan",    amount: "2,400" },
  { month: "Feb",    amount: "2,400" },
  { month: "Mar",    amount: "2,400" },
  { month: "Apr",    amount: "2,400" },
];

const documents = [
  ["10th Marksheet",        "3 Copies"],
  ["12th Marksheet",        "3 Copies"],
  ["Transfer Certificate",  "Original + 3 Copies"],
  ["Character Certificate", "Original + 3 Copies"],
  ["Migration",             "Original + 3 Copies"],
  ["Apaar ID",              "1"],
  ["Aadhaar ID",            "1"],
  ["Passport Photo",        "5"],
];

const notes = [
  "Mask Compulsory. Do not share Water and Lunch Box with any students.",
  "Fees once paid shall not be refunded under any circumstances, except caution money.",
  "After 10th of every month ₹10/- per day Late fees will be charged (For daily basis).",
  "Excluded exam fees as per JNVU norms are applicable.",
  "University Registration would be charged as per the norms of university applicable during the specific session.",
  "Upto 10% fees will be increased in BSc 2nd year and BSc 3rd year respectively.",
  "Caution money only refunds with your original receipt (please take care of receipt).",
];

export default function Bsc(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div>
      <Header
        color="white"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{ height: 200, color: "white" }}
        {...rest}
      />

      <div className={classNames(classes.main)} style={{ marginTop: 110, backgroundColor: "white" }}>
        <AdmissionEnquiry openModal={openModal} handleCloseModal={() => setOpenModal(false)} courseName="bsc" />

        <div className={classes.container} style={{ padding: "24px 16px" }}>

          {/* Title + Enroll */}
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} sm={8} md={9}>
              <h2 style={{ fontSize: 26, fontFamily: "Rubik, sans-serif", fontWeight: "700", color: darkBlueColor, margin: "0 0 12px" }}>
                Bachelor of Science — Physics, Chemistry & Mathematics (BSc-PCM)
              </h2>
              <p style={{ color: grayTextColor, fontSize: 15, fontFamily: "Rubik, sans-serif", textAlign: "justify", lineHeight: 1.8, margin: 0 }}>
                BSc PCM combines interdisciplinary concepts of Physics, Chemistry, and Mathematics, allowing students to specialize in any one domain. The course incorporates upcoming technological changes and gives students first-hand knowledge — making it the best option for those passionate about science and mathematics.
              </p>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Button
                variant="contained"
                fullWidth
                onClick={() => setOpenModal(true)}
                style={{ backgroundColor: yelloColor, color: darkBlueColor, fontFamily: "Rubik, sans-serif", fontWeight: "700", padding: "12px 0", fontSize: 15 }}
              >
                Enroll Now
              </Button>
              <Paper style={{ backgroundColor: "#f4f6fb", padding: "12px 16px", marginTop: 12 }}>
                <Typography style={{ color: "#7b838a", fontFamily: "Rubik, sans-serif", fontSize: 13 }}>Course Duration</Typography>
                <Typography style={{ color: darkBlueColor, fontFamily: "Rubik, sans-serif", fontWeight: "700", fontSize: 16 }}>3 Years</Typography>
              </Paper>
            </Grid>
          </Grid>

          {/* Course Overview */}
          <SectionCard title="Course Overview" noPadding>
            <Table style={{ width: "100%" }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell style={{ width: "35%" }}>Detail</StyledTableCell>
                  <StyledTableCell>Information</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {infoRows.map(([label, value]) => (
                  <StyledTableRow key={label}>
                    <StyledTableCell component="th" scope="row" style={{ fontWeight: "700" }}>{label}</StyledTableCell>
                    <StyledTableCell>{value}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </SectionCard>

          {/* Fees Structure */}
          <SectionCard title="Fees Structure (JNVU 2026-27) — BSc PCM" noPadding>
            <Table style={{ width: "100%" }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell style={{ width: "75%" }}>Particular</StyledTableCell>
                  <StyledTableCell align="center" style={{ width: "25%" }}>Amount (₹)</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bscPcmFees.map(([name, amount]) => (
                  <StyledTableRow key={name}>
                    <StyledTableCell component="th" scope="row">{name}</StyledTableCell>
                    <StyledTableCell align="center">{amount}</StyledTableCell>
                  </StyledTableRow>
                ))}
                <TableRow style={{ backgroundColor: darkBlueColor }}>
                  <TableCell style={{ fontFamily: "Rubik, sans-serif", fontSize: 16, color: "white", fontWeight: "700", padding: "12px 16px" }}>TOTAL</TableCell>
                  <TableCell align="center" style={{ fontFamily: "Rubik, sans-serif", fontSize: 16, color: "white", fontWeight: "700", padding: "12px 16px" }}>₹26,000</TableCell>
                </TableRow>
                <TableRow style={{ backgroundColor: "#fdc632" }}>
                  <TableCell style={{ fontFamily: "Rubik, sans-serif", fontSize: 15, color: "#002347", fontWeight: "700", padding: "12px 16px" }}>One Time Payment</TableCell>
                  <TableCell align="center" style={{ fontFamily: "Rubik, sans-serif", fontSize: 15, color: "#002347", fontWeight: "700", padding: "12px 16px" }}>₹26,000/-</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </SectionCard>

          {/* Monthly Installments */}
          <SectionCard title="Monthly Installments">
            <Grid container spacing={1}>
              {installments.map(({ month, amount }) => (
                <Grid item xs={6} sm={4} md={2} key={month}>
                  <div style={{ border: "1px solid #e0e8f0", borderRadius: 6, textAlign: "center", padding: "10px 8px", backgroundColor: "#f8faff" }}>
                    <div style={{ fontSize: 12, color: "#7b838a", fontFamily: "Rubik, sans-serif", fontWeight: "600", textTransform: "uppercase", letterSpacing: 0.5 }}>{month}</div>
                    <div style={{ fontSize: 15, color: "#002347", fontFamily: "Rubik, sans-serif", fontWeight: "700", marginTop: 4 }}>₹{amount}</div>
                  </div>
                </Grid>
              ))}
            </Grid>
          </SectionCard>

          {/* Required Documents */}
          <SectionCard title="Required Documents" noPadding>
            <Table style={{ width: "100%" }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Document</StyledTableCell>
                  <StyledTableCell align="center">Copies Required</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {documents.map(([doc, copies]) => (
                  <StyledTableRow key={doc}>
                    <StyledTableCell component="th" scope="row">{doc}</StyledTableCell>
                    <StyledTableCell align="center">{copies}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </SectionCard>

          {/* Notes */}
          <SectionCard title="Important Notes">
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {notes.map((note, i) => (
                <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                  <span style={{ color: "#fdc632", fontWeight: "bold", fontSize: 16, flexShrink: 0, lineHeight: 1.5 }}>★</span>
                  <p style={{ fontFamily: "Rubik, sans-serif", color: "#444", fontSize: 14, margin: 0, lineHeight: 1.7 }}>{note}</p>
                </div>
              ))}
            </div>
          </SectionCard>
        </div>
      </div>
      <Footer />
    </div>
  );
}
